export interface IdentityClaims {
  email?: unknown;
  preferred_username?: unknown;
  [claim: string]: unknown;
}

function normalizedString(value: unknown): string | undefined {
  return typeof value === "string" && value.trim()
    ? value.trim().toLowerCase()
    : undefined;
}

export function emailFromClaims(
  claims: IdentityClaims | undefined,
): string | undefined {
  const email = normalizedString(claims?.email);
  if (email) {
    return email;
  }

  const username = normalizedString(claims?.preferred_username);
  return username?.includes("@") ? username : undefined;
}
